module.exports = __webpack_public_path__ + "img/kit-logo.6d94afc1.svg";